import React, { useEffect, useState } from 'react';

import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const SplitTheGroup = () => {
  const [candyCount, setCandyCount] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('');
  const [showPlayAgain, setShowPlayAgain] = useState(false);
  const emoji = '🧁';

  const startGame = () => {
    // const count = Math.floor(Math.random() * 13) + 8; // 8–20
    const count = Math.floor(Math.random() * (30 - 8 + 1)) + 8;
    setCandyCount(count);
    setFeedback('');
    setShowPlayAgain(false);
  };

  const checkAnswer = (groupSize) => {
    if (candyCount % groupSize === 0) {
      setFeedback(`✅ Yes! ${candyCount} can be split evenly into groups of ${groupSize}.`);
      setFeedbackColor('#2e7d32');
    } else {
      setFeedback(`❌ No! ${candyCount} can't be split evenly into groups of ${groupSize}.`);
      setFeedbackColor('#c62828');
    }
    setShowPlayAgain(true);
  };

  useEffect(() => {
    startGame();
  }, []);

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: '#fff3e0',
      textAlign: 'center',
      padding: '30px',
      color: '#5d4037',
      minHeight: '100vh',
    },
    h1: {
      fontSize: '2.5rem',
      marginBottom: '10px',
    },
    candyContainer: {
      margin: '20px auto',
      maxWidth: '300px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    candy: {
      fontSize: '2rem',
      margin: '5px',
    },
    question: {
      fontSize: '1.6rem',
      marginTop: '30px',
    },
    groupBtn: {
      fontSize: '1.4rem',
      margin: '10px',
      padding: '10px 20px',
      backgroundColor: '#ffb74d',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      transition: 'background 0.3s',
    },
    feedback: {
      fontSize: '1.6rem',
      marginTop: '20px',
      height: '40px',
      color: feedbackColor,
    },
    playAgain: {
      display: showPlayAgain ? 'inline-block' : 'none',
      marginTop: '30px',
      padding: '12px 30px',
      fontSize: '1.4rem',
      backgroundColor: '#4db6ac',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
    },
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>🍬 Who Can Split the Group?</h1>
      <p>Can you split the candies evenly into different groups?</p>

      <div style={styles.candyContainer}>
        {Array.from({ length: candyCount }).map((_, i) => (
          <div key={i} style={styles.candy}>{emoji}</div>
        ))}
      </div>

      <div style={styles.question}>
        Can you split {candyCount} candies evenly into these groups?
      </div>

      <div>
        {[2, 3, 4, 5, 6].map(groupSize => (
          <button
            key={groupSize}
            style={styles.groupBtn}
            onClick={() => checkAnswer(groupSize)}
          >
            Groups of {groupSize}
          </button>
        ))}

        {/* "None of These" button */}
        <button
          style={{
            ...styles.groupBtn,
            backgroundColor: '#e57373'
          }}
          onClick={() => {
            const isDivisible = [2, 3, 4, 5, 6].some(num => candyCount % num === 0);
            if (!isDivisible) {
              setFeedback(`✅ Correct! ${candyCount} cannot be split evenly into any of these groups.`);
              setFeedbackColor('#2e7d32');
                  const responsedata = ConstructorEventUpdateSQLStatus();
    console.log("Event completed", responsedata);
            } else {
              setFeedback(`❌ Actually, ${candyCount} *can* be divided evenly by one or more of those groups.`);
              setFeedbackColor('#c62828');
            }
            setShowPlayAgain(true);
          }}
        >
          ❌ None of These
        </button>
      </div>

      <div style={styles.feedback}>{feedback}</div>

      <button style={styles.playAgain} onClick={startGame}>🔁 Play Again</button>
    </div>
  );
};

export default SplitTheGroup;
